import { z } from "zod";

import { CsvEnrichmentType } from "@/enum/csv-enrichment.enum";
import { CustomEventType } from "@/enum/custom-event.enum";
import { ScrapeLevel } from "@/enum/job.enum";
import { ListSourceType } from "@/enum/list.enum";

// Smart-list AI "recommend a list type" feature schemas. Extracted out of the large
// list.ts schema module to keep it within the file-length ratchet; re-exported from
// list.ts so existing imports keep working.

export const ListCreateRecommendationRecurrenceSchema = z.enum(["ONE_TIME", "RECURRING"]);

export const ListCreateRecommendationRequirementSchema = z.enum([
	"LINKEDIN_ACCOUNT",
	"SALES_NAVIGATOR",
	"COMPANY_ADMIN",
	"WEBSITE_SCRAPE_CREDITS",
	"TRACKER_AS_LIST_FEATURE",
	"SMART_LIST_FEATURE",
]);

export const ListCreateRecommendationAvailableTypeSchema = z.object({
	id: z.string().min(1),
	sourceType: z.nativeEnum(ListSourceType),
	entityType: z.union([z.nativeEnum(CsvEnrichmentType), z.nativeEnum(CustomEventType)]).nullable(),
	scrapeLevel: z.nativeEnum(ScrapeLevel).nullable(),
	title: z.string().min(1),
	description: z.string().min(1),
	recurrences: z.array(ListCreateRecommendationRecurrenceSchema).min(1),
	requirements: z.array(ListCreateRecommendationRequirementSchema),
	keywords: z.string(),
});

export const ListCreateRecommendationRequestSchema = z.object({
	prompt: z.string().trim().min(3).max(1000),
	availableTypes: z.array(ListCreateRecommendationAvailableTypeSchema).max(50),
});

export const ListCreateRecommendationItemSchema = z.object({
	id: z.string().min(1),
	confidence: z.number().min(0).max(1),
	reason: z.string().min(1),
});

export const ListCreateRecommendationResponseSchema = z.object({
	summary: z.string(),
	recommendations: z.array(ListCreateRecommendationItemSchema).max(3),
});

export type ListCreateRecommendationAvailableType = z.infer<
	typeof ListCreateRecommendationAvailableTypeSchema
>;
export type ListCreateRecommendationRequest = z.infer<typeof ListCreateRecommendationRequestSchema>;
export type ListCreateRecommendationResponse = z.infer<
	typeof ListCreateRecommendationResponseSchema
>;
